import React, { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../store";
import { get_total_training } from "../services/apis/training";
import { get_total_service } from "../services/apis/services";
import { get_total_request } from "../services/apis/requests";
import { get_total_opportunity } from "../services/apis/opportunity";
import { get_total_company } from "../services/apis/companies";
import { get_total_user } from "../services/apis/users";

export const useAnalytics = () => {
  const dispatch = useAppDispatch();
  const { loading: loadTraining, counts: trainingCounts } = useAppSelector(
    ({ training }) => training,
  );
  const { loading: loadService, counts: serviceCounts } = useAppSelector(
    ({ service }) => service,
  );
  const loadRequest = useAppSelector(({ request }) => request.loading);
  const requestCounts = useAppSelector(({ request }) => request.total);
  const { loading: loadOpportunity, counts: opportunityCounts } =
    useAppSelector(({ opportunity }) => opportunity);
  const { loading: loadCompany, counts: companyCounts } = useAppSelector(
    ({ companies }) => companies,
  );
  const { loading: loadUser, counts: userCounts } = useAppSelector(
    ({ user }) => user,
  );

  const onLoad = useCallback(() => {
    get_total_training(dispatch);
    get_total_service(dispatch);
    get_total_request(dispatch);
    get_total_opportunity(dispatch);
    get_total_company(dispatch);
    get_total_user(dispatch);
  }, [dispatch]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);
  return {
    loadTraining,
    trainingCounts,
    loadService,
    serviceCounts,
    loadRequest,
    requestCounts,
    loadOpportunity,
    opportunityCounts,
    loadCompany,
    companyCounts,
    loadUser,
    userCounts,
  };
};
